import { QueryClient, QueryClientProvider, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Toaster } from 'sonner';
import { AppRouter } from './app/router';
import { wsClient } from './lib/ws';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

function WsInvalidator() {
  const qc = useQueryClient();
  useEffect(() => {
    const offTickets = wsClient.join('tickets', () => {
      qc.invalidateQueries({ queryKey: ['tickets'] });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    });
    const offUsers = wsClient.join('users', () => {
      qc.invalidateQueries({ queryKey: ['users'] });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    });
    return () => {
      offTickets();
      offUsers();
    };
  }, [qc]);
  return null;
}

export function App() {
  useEffect(() => {
    wsClient.connect();
    return () => wsClient.close();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <WsInvalidator />
      <AppRouter />
      <Toaster theme="dark" richColors />
    </QueryClientProvider>
  );
}
